import { render } from "./OurLeadership.vue?vue&type=template&id=43af4bb0&scoped=true"
import script from "./OurLeadership.vue?vue&type=script&lang=js"
export * from "./OurLeadership.vue?vue&type=script&lang=js"

import "./OurLeadership.vue?vue&type=style&index=0&id=43af4bb0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43af4bb0"]])

export default __exports__